import { uuid } from '../utils';
import {
  ILLUSTRATION
} from './categories';

export default {
  id: uuid(),
  priority: 2,
  name: 'Storms',
  thumbnail: './Storms/Storms_Thumb.jpg',
  categories: [ ILLUSTRATION ],
  content: [
    './Storms/Storm-beach.jpg',
    './Storms/Storm03.jpg',
    './Storms/Storm01.jpg',
    './Storms/Nosebleed.jpg',
    './Storms/Kometfresser.jpg',
    './Storms/Bear-feel.jpg',
    './Storms/Titaninen.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/storms.js